import Post from "../Post";
import getToken from "../token";

export default function getChatMessages(
  consultationId,
  number,
  sender = "user"
) {
  return Post("counseling/counselingMessages", {
    token: getToken(),
    counselingId: consultationId,
    limit: number,
    sender: sender,
    page: 1,
  });
}
